import { createStore, Store } from "redux";
import reducer, { RootState } from "./reducer";

// ==============================|| REDUX - MAIN STORE ||============================== //

const store: Store<RootState> = createStore(reducer);
const persister = "Free";

export { store, persister };
